<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex" style="margin-right: 12px">
      <v-tabs color="primary accent-4 mr-2" v-model="tab" right>
        <p class="text-h6 mr-auto mt-2">
          Inbound {{ capitalizeFirstLetter(type) }} Transaction
        </p>
        <v-tab @click="(type = 'receiving'), callApi()">Receiving</v-tab>
        <v-tab @click="(type = 'putaway'), callApi()">Putaway</v-tab>
      </v-tabs>
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-card class="pl-0">
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="pl-0">
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Order Details </b>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">ASN/Receipt</div>
                <div class="text-left col-md-7 p-0">
                  {{ orderDetails.receipt_key }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Receipt No</div>
                <div class="text-left col-md-7 p-0">
                  {{ orderDetails.external_receipt_number }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Status</div>
                <div class="text-left col-md-7 p-0">
                  {{ orderDetails.status_label }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Created At</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="orderDetails.created_datetime"
                >
                  {{
                    orderDetails.created_datetime
                      | localMomentNew
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Updated At</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="orderDetails.updated_datetime"
                >
                  {{
                    orderDetails.updated_datetime
                      | localMomentNew
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
                <v-btn
                  @click="exportToCSV"
                  color="primary"
                  small
                  v-if="type == 'putaway'"
                  >Export Data</v-btn
                >
              </div>
            </v-col>
          </v-col>
        </v-row>
        <v-divider class="mb-5"></v-divider>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="listData"
              :options.sync="options"
              :server-items-length="total"
              :loading="inboundOrderLoader"
              class="elevation-1 custom-icon-size"
              :footer-props="{
                itemsPerPageOptions: [25, 50, 100, 250],
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
              }"
            >
              <template v-slot:[`item.warehouse_id__name`]="{ item }">
                {{ item.warehouse_id__name }}<br />({{ item.storer_key }})
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <span v-if="item.created_at">{{
                  item.created_at
                    | localMomentformat
                    | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                <span v-if="item.updated_at">{{
                  item.updated_at
                    | localMomentformat
                    | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Parser } from "json2csv";

export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    inboundOrderLoader: false,
    orderDetails: {},
    headers: [
      {
        text: "ASN/Receipt",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Warehouse (Storer)",
        value: "warehouse_id__name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Transaction ID",
        value: "transaction_id",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Transaction Type",
        value: "transaction_type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Receiving Transaction Header ID",
        value: "receiving_transaction_header_id",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Receiving Transaction Interface ID",
        value: "receiving_transaction_interface_id",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Receipt Line No.",
        value: "receipt_linenumber",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "External Receipt No.",
        value: "external_receipt_number",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "LOT",
        value: "lot",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Receiving Date",
        value: "receiving_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Source Type",
        value: "source_type",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Supplier code",
        value: "supplier_code",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },

      {
        text: "PO line number",
        value: "po_linenumber",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Expiry Date",
        value: "expiry_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Quantity",
        value: "quantity",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Comment",
        value: "comment",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 200,
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Status Code",
        value: "status_code",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Status Description",
        value: "status_description",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },

      {
        text: "Transaction Date",
        value: "transaction_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    listData: [],
    type: "receiving",
  }),

  watch: {
    options: {
      handler() {
        this.callApi();
      },
      deep: true,
    },
  },
  created() {},

  methods: {
    ...mapActions(["snackBar", "getTransactionInboundList"]),

    exportToCSV() {
      // Map headers to a structure that json2csv expects, with 'label' and 'value'
      const fields = this.headers.map((header) => ({
        label: header.text, // Use 'text' as the CSV column header
        value: (row) => {
          // Force the lot number to be treated as a string by wrapping it in quotes
          if (
            header.value === "lot" ||
            header.value === "receipt_key" ||
            header.value === "transaction_id" ||
            header.value === "receipt_linenumber"
          ) {
            return `\t${row[header.value]}`; // Add quotes to preserve leading zeros
          }
          // Return other fields normally
          return row[header.value];
        },
      }));

      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(this.listData);

      // Create a download link and trigger it
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "Inbound Putaway Transaction.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    callApi() {
      let payload = {
        inbound_id: this.$route.query.id,
        type: this.type,
        ...this.options,
      };
      this.getTransactionInboundList(payload).then((response) => {
        this.orderDetails = response.data.order_details[0];
        this.listData = response.data.records;
        this.total = response.data.total;
      });
    },
  },
};
</script>

<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 0px 5px 5px !important;
}
.p-0 {
  padding: 0px !important;
}
</style>
